module.exports = "/images/airborne-disease@3x.png?c26d4a712f2d02dc20e10372478a48b1";